import { SetStateAction, useEffect, useState } from 'react'
import { TitleH1 } from '../../../Components/CustomUi/titleH1'
import PageContainer from '../../../Components/pageContainer'
import { TabelaCargos } from '../cadastros/cadastroCargos/components/tabela'
import {
  useGetComandos,
  useGetEditarComandos,
  useGetEquipeAtivo,
} from '../../../services/cadastroComandos/GET'
import { TabelaComando } from './components/tabela'
import { FormularioComando } from './components/formulario'
import { usePostComando, usePostComandoEditar } from '../../../services/cadastroComandos/POST'
import { useDeleteComando } from '../../../services/cadastroComandos/DELETE'

const CadastroComando: React.FC = () => {
  //FORMULARIO
  const [openGaveta, setOpenGaveta] = useState<boolean>(false)
  const [update, setUpdate] = useState<number>(null)
  const [usuarios_selecionados, setUsuarios_selecionados] = useState<
    { descr: string; id: number; key?: number }[]
  >([])
  const [descricao, setDescricao] = useState<string>('')
  const [comando, setComando] = useState<string>('')
  const [tipo, setTipo] = useState<string>('')
  const [tipoId, setTipoId] = useState<number>(null)
  const [log, setLog] = useState<string>(null)
  const [dataUsuarios, setDataUsuarios] = useState([])
  const [cod_aplicativo, setCod_aplicativo] = useState<string>(null)

  //TABELA
  const [buscarTabela, setBuscarTabela] = useState<string>('')
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)

  //API
  const { carregando_comandos, data_comandos, refetch_data_comandos } = useGetComandos(
    pagination,
    page,
    buscarTabela
  )
  const { carregando_comandos_editar, data_comandos_editar, refetch_data_comandos_editar } =
    useGetEditarComandos(update)
  const { data_usuarios_ativos, refetch_data_usuarios_ativos } = useGetEquipeAtivo()
  const { carregando_salvar_comando, mutate_comando } = usePostComando()
  const { carregando_salvar_comando_editar, mutate_comando_editar } = usePostComandoEditar(update)
  const { mudate_deletar_comando } = useDeleteComando()

  function abrir() {
    setOpenGaveta(true)
  }

  function editarComando(cod) {
    setUpdate(cod)
    setOpenGaveta(true)
  }

  function fecharGaveta() {
    setOpenGaveta(false)
    setUpdate(null)
    setUsuarios_selecionados([])
    setDescricao('')
    setComando('')
    setTipo('')
    setTipoId(null)
    setLog(null)
    refetch_data_comandos()
    setCod_aplicativo(null)
  }

  function cadastrarComando() {
    if (update <= 0) {
      mutate_comando({
        usuarios: usuarios_selecionados?.map((item) => item?.id),
        descricao: descricao,
        comando: comando,
        tipo: tipoId,
        refetch_comando: fecharGaveta,
      })
    } else {
      mutate_comando_editar({
        descricao: descricao,
        refetch_comando: fecharGaveta,
      })
    }
  }

  function deletarComando(cod) {
    setFake_loading(true)

    mudate_deletar_comando({
      cod_comando: cod,
      refetch_deletar: refetch_data_comandos,
    })

    setTimeout(() => {
      setFake_loading(false)
    }, 800)
  }

  useEffect(() => {
    if (update > 0) {
      refetch_data_comandos_editar()
    }
  }, [update])

  useEffect(() => {
    if (data_comandos_editar?.itens?.length > 0) {
      const usuarios = (data_comandos_editar?.itens).map((item) => {
        return {
          descr: `${item?.cod_usuario} - ${item?.usuario_nome}`,
          id: item?.cod_usuario,
          key: item?.cod_usuario,
        }
      })
      setUsuarios_selecionados(usuarios)
      setDescricao(data_comandos_editar?.itens[0]?.descricao)
      setComando(data_comandos_editar?.itens[0]?.token)
      setLog(data_comandos_editar?.itens[0]?.log)
      setTipo(data_comandos_editar?.itens[0]?.tipo_nome)
      setTipoId(data_comandos_editar?.itens[0]?.tipo)
      setCod_aplicativo(
        String(
          data_comandos_editar?.itens[0]?.cod_aplicativo === null
            ? ''
            : data_comandos_editar?.itens[0]?.cod_aplicativo
        )
      )
    }
  }, [data_comandos_editar])

  useEffect(() => {
    if (data_usuarios_ativos?.itens.length > 0) {
      const usuarios = data_usuarios_ativos?.itens.map((item) => {
        return {
          cod: item?.cod,
          nome: `${item?.cod} - ${item?.nome}`,
        }
      })
      setDataUsuarios(usuarios)
    }
  }, [data_usuarios_ativos])

  useEffect(() => {
    refetch_data_comandos()
    refetch_data_usuarios_ativos()
  }, [])

  return (
    <PageContainer>
      <TitleH1>Comandos</TitleH1>
      <TabelaComando
        setPagination={setPagination}
        setPage={setPage}
        page={page}
        listar_comandos={data_comandos?.itens}
        carregando_comandos={carregando_comandos}
        total={data_comandos?.total}
        excluir_comando={deletarComando}
        confirmar_exclusao={confirmar_exclusao}
        buscarTabela={buscarTabela}
        abrir={abrir}
        setBuscarTabela={setBuscarTabela}
        editar={editarComando}
        setConfirmar_exclusao={setConfirmar_exclusao}
        id_item_atual={id_item_atual}
        setId_item_atual={setId_item_atual}
        nome_item_atual={nome_item_atual}
        setNome_item_atual={setNome_item_atual}
        fake_loading={fake_loading}
        setFake_loading={setFake_loading}
      />
      <FormularioComando
        open={openGaveta}
        fecharGaveta={fecharGaveta}
        update={update}
        usuarios_selecionados={usuarios_selecionados}
        setUsuarios_selecionados={setUsuarios_selecionados}
        descricao={descricao}
        setDescricao={setDescricao}
        comando={comando}
        setComando={setComando}
        tipo={tipo}
        setTipo={setTipo}
        setTipoId={setTipoId}
        cod_aplicativo={cod_aplicativo}
        setCod_aplicativo={setCod_aplicativo}
        data_usuario={dataUsuarios}
        log={log}
        cadastrarComando={cadastrarComando}
        loadingSalvar={carregando_salvar_comando ?? carregando_salvar_comando_editar}
        loadingForm={carregando_comandos_editar}
      />
    </PageContainer>
  )
}

export default CadastroComando